module.exports = __webpack_public_path__ + "img/4.907dea0d.png";